import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withRouter, Redirect} from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import Form from './Form'

import style from './signup.sass'

@withRouter
@inject('store') @observer
class Signup extends Component {
  componentDidMount() {
    const planID = this.props.match.params.id
    if (planID) {
      this.props.store.signup.setBillingPlan(planID)
      this.props.store.signup.resetComplete()
    }
  }
  render() {
    const planID = this.props.match.params.id
    if (['1','2','3'].indexOf(planID) === -1) {
      return <Redirect to='/signup'/>
    }
    if (this.props.store.signup.complete) {
      return <Redirect to='/signup-complete'/>
    }

    return(
      <div>
        <DocumentTitle title='Sign Up'/>
        <div styleName='banner'/>
        <section className='bg-white'>
          <div className='landing-container' styleName='container'>
            <h3>Sign up to start building Trading Algos</h3>
            <Form/>
          </div>
        </section>
      </div>
    )
  }
}

export default Signup
